module.exports = __webpack_public_path__ + "img/example_2.708663a2.png";